module.exports = __webpack_public_path__ + "img/rondferme.fd3444c1.svg";